import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { ValidState } from "@/models/enum/Enum";

type Props = {
  value: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialCommitChip',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: string;
};



const isValid = computed(() => props.value === ValidState.Valid);

const isNone = computed(
  () => props.value !== ValidState.Valid && props.value !== ValidState.InValid
);

const color = computed(() => (isValid.value ? "primary" : "error"));
const message = computed(() => (isValid.value ? "あり" : "なし"));

return { __sfc: true,props, isValid, isNone, color, message }
}

})